export default [
    {
        path: "skusales/list",
        name: "skuSalesList",
        component: () => import(/* webpackChunkName: "stp" */ "@/views/skusales/index"),
    },
    {
        path: "skusales/update/:type",
        name: "skuSalesUpdate",
        component: () => import(/* webpackChunkName: "stp" */ "@/views/skusales/update"),
    },
]